import React from 'react';
import ContactSection from '../Contact/ContactSection';
import MapComponent from '../Map/Map';

function Contact() {
    return (
        <>
            <ContactSection />
            <MapComponent />
        </>
    )
}

export default Contact
